import React from 'react';
import styled from 'styled-components';
import { gemstoneDetails } from '../data/gemstoneData';

const ListSection = styled.section`
  padding: 60px 40px 100px;
  background: white;
`;

const Container = styled.div`
  max-width: ${props => props.theme.spacing.container};
  margin: 0 auto;
`;

const Title = styled.h2`
  font-size: 36px;
  text-align: center;
  margin-bottom: 60px;
  color: ${props => props.theme.colors.primary};
  font-weight: 300;
  letter-spacing: 2px;
  
  &:after {
    content: '';
    display: block;
    width: 60px;
    height: 2px;
    background: ${props => props.theme.colors.secondary};
    margin: 20px auto;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  max-width: 1000px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const GemstoneCard = styled.div`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0,0,0,0.1);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 25px 45px rgba(0,0,0,0.15);
  }
`;

const GemImage = styled.img`
  width: 100%;
  height: 220px;
  object-fit: contain;
  object-position: center;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  background-color: #f8f9fa;
  display: block;
`;

const GemInfo = styled.div`
  padding: 25px;
`;

const GemName = styled.h3`
  font-size: 24px;
  margin-bottom: 15px;
  color: ${props => props.theme.colors.primary};
  font-weight: 500;
  position: relative;
  padding-bottom: 10px;
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 50px;
    height: 2px;
    background: ${props => props.theme.colors.secondary};
  }
`;

const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 15px;
  background: #f8f9fa;
  padding: 12px;
  border-radius: 8px;
`;

const DetailItem = styled.div`
  font-size: 13px;
  
  strong {
    color: ${props => props.theme.colors.secondary};
    font-weight: 600;
    display: block;
    margin-bottom: 4px;
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.5px;
  }
  
  span {
    color: #555;
    font-size: 14px;
    font-weight: 500;
  }
`;

const Description = styled.p`
  font-size: 14px;
  line-height: 1.7;
  color: #444;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #eee;
`;

const GemstoneList = () => {
  return (
    <ListSection>
      <Container>
        <Title>The Ten Most Popular Gemstones</Title>
        <Grid>
          {gemstoneDetails.map((gem) => (
            <GemstoneCard key={gem.id}>
              <GemImage src={gem.image} alt={gem.name} />
              <GemInfo>
                <GemName>{gem.name}</GemName>
                <DetailGrid>
                  <DetailItem>
                    <strong>Hardness</strong>
                    <span>{gem.hardness || "N/A"}</span>
                  </DetailItem>
                  <DetailItem>
                    <strong>Color</strong>
                    <span>{gem.color || "N/A"}</span>
                  </DetailItem>
                  <DetailItem>
                    <strong>Birthstone</strong>
                    <span>{gem.birthstone || "N/A"}</span>
                  </DetailItem>
                </DetailGrid>
                <Description>{gem.description || "Detailed information coming soon."}</Description>
              </GemInfo>
            </GemstoneCard>
          ))}
        </Grid>
      </Container>
    </ListSection>
  );
};

export default GemstoneList;
